import React, { Component } from 'react';
import PropTypes from 'prop-types';
import QRCode from 'qrcode.react';
import { withRouter } from 'withRouter'
import slugify from 'react-slugify';
import ProcessPage from 'components/ProcessPage';
import InfoBox from 'components/InfoBox';
import { enableTwoFactor } from 'api/auth';
import VerificationCode from 'components/Verification';
import { defaultNotifier } from 'functions/notificationHandler';
import RecoveryKey from 'containers/Settings/User/Detail/components/RecoveryKey';
import { routeMapping } from 'routes';
import SsoPage from 'containers/Auth/SSO/SsoPage';
import { VuiButton } from '@topkamera/viso-ui';
import Modal from 'components/Modal';
import { FormattedMessage } from 'react-intl';
import appMessages from 'utils/messages';

class BarcodeReader extends Component {
  state = {
    codes: [],
    activeIndex: 0,
  }

  redirectToHome = () => {
    const { workspace } = this.props;
    const wsPath = slugify(workspace.name);
    this.props.onCloseAllPage();

    this.props.fetchMe(() => this.props.router.navigate(`/${wsPath}${routeMapping.SETTINGS.path}`));
  }

  onChange = (e, index) => {
    const value = e.key || e.currentTarget.value;

    this.state.codes[index] = value;
    this.setState({ activeIndex: parseInt(index, 10) + 1 });
    this.setState({ codes: this.state.codes });
  }

  onUpdate = value => this.setState({ codes: value })

  onModalClose = () => {
    this.setState({ renderModal: false });
  }

  onShowModal = () => {
    this.setState({ renderModal: true });
  }

  onSubmit = async () => {
    const code = this.state.codes.reduce((sum, item) => `${sum}${item}`);

    if (code.length === 6) {
      const { data } = await enableTwoFactor({ code });

      if (data.errors) {
        return defaultNotifier(data.errors);
      }

      this.setState({ showRecoveryPage: true });
      defaultNotifier('Two factor authentication enabled.');
    }
  }

  renderManualModal = () => {
    const { qrCodeString, me, workspace } = this.props;

    const buttons = [
      <button className="modal__cancel" key="cancel" onClick={this.onModalClose}>
        <FormattedMessage {...appMessages.cancel} />
      </button>,
    ];

    return (
      <Modal
        buttons={buttons}
        title={'Can\'t scan the code?'}
        body={(
          <p className="text-color">
            To add the entry manually, provide the following details to the application on your phone.
            <div className="mx-t-10 label-color">
              <div>
                <span>Issuer</span>
                : viso.ai
              </div>
              <div>
                <span>Account</span>
                :
                {' '}
                {workspace.name}
                :
                {me && me.email}
              </div>
              <div>
                <span>Secrets</span>
                :
                {' '}
                {qrCodeString && qrCodeString.secret}
              </div>
            </div>
          </p>
        )}
        onClose={this.onModalClose}
      />
    );
  }

  render() {
    const { workspace, me } = this.props;
    const code = this.state.codes.length && this.state.codes.reduce((sum, item) => `${sum}${item}`);

    const theme = workspace.contrast;
    if (this.state.showRecoveryPage) {
      return (
        <RecoveryKey
          disabled
          downloadInfo={`${workspace && workspace.name}:${me && me.email}`}
          fetchMe={this.props.fetchMeRequest}
          onClose={this.redirectToHome}
        />
      );
    }

    return (
      <ProcessPage onCancel={this.props.onClose} splitPage={true} customClass='split-page-full-height-popup'>
        {() => (
          <>
            {this.state.renderModal && this.renderManualModal()}
            <SsoPage
              title={'Set up authenticator app'}
              gap={40}
            >
              <div className='sso-page-form sso-page-form--350'>
                <InfoBox
                  text='Scan the QR code with your authenticator app. Then enter the code to enable two-step verification for your account.'
                  textSize='small'
                />
                <div className='sso-page-field vui-flex vui-justify-center vui-py-20'>
                  <div className='vui-p-10'>
                    <QRCode
                      bgColor={theme === 'light' ? 'white' : '#232323'}
                      fgColor={theme === 'light' ? 'black' : 'white'}
                      size='134'
                      value={this.props.value}
                    />
                  </div>
                </div>
                <div className='sso-page-field vui-pb-20'>
                  <VerificationCode
                    codes={this.state.codes}
                    onUpdate={this.onUpdate}
                    activeIndex={this.state.activeIndex}
                    onChange={this.onChange}
                  />
                </div>
                <div className="sso-page-form__button sso-page-form__button--270">
                  <VuiButton
                    disabled={code.length !== 6}
                    color='accent0'
                    style='filled'
                    radius='pill'
                    label='Continue'
                    onClick={this.onSubmit}
                    isBlock
                  />
                  <div className="vui-text-center vui-body-sm vui-pt-20">
                    <a href='#useKey'
                      className="accent0"
                      onClick={(e) => {
                        e.preventDefault()
                        this.onShowModal()
                      }}
                    >
                      Can't scan the QR code?
                    </a>
                  </div>
                </div>
              </div>
            </SsoPage>
          </>
        )}
      </ProcessPage>
    );
  }
}

BarcodeReader.propTypes = {
  color: PropTypes.string,
  image: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default withRouter(BarcodeReader);
